import { React, useRef, useEffect, useState } from 'react';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import Button from '@mui/material/Button';
import Fab from '@mui/material/Fab';
import TextField from '@mui/material/TextField';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import DeleteIcon from '@mui/icons-material/Delete';
import AlertDialog from '../Modals/AlertDialog'
import ErrorIcon from '@mui/icons-material/Error';
import styles from './PickupWizard.module.css'; // Import css modules stylesheet as styles
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import IconButton from '@mui/material/IconButton';
import StyledRadio from '../StyledExtensions/StyledRadio'
import Paper from '@mui/material/Paper';
import { TextArea } from 'antd-mobile';
import AddAPhotoIcon from '@mui/icons-material/AddAPhoto';

// Take a photo example
//https://codesandbox.io/s/vj1q68zm25

export default function QuantityPanel(props) {
    const [quantity, setQuantity] = useState(props.pickupRequest.Quantity !== undefined ? props.pickupRequest.Quantity : '');
    const [photos, setPhotos] = useState(props.pickupRequest.Photos !== undefined ? props.pickupRequest.Photos : []);
    const [formErrors, setFormErrors] = useState([]);
    const [images, setImages] = useState(props.pickupRequest.Photos !== undefined ? props.pickupRequest.Photos : []);
    const imageInputRef = useRef(null);
    const [alertDialog, setAlertDialog] = useState({
        show: false,
        title: '',
        message: '',
        closeButton: '',
    });

    useEffect(() => {
       
    });

    function showMoreInfo(infoType) {
        if (infoType == 'Quantity') {
            setAlertDialog({
                show: true,
                title: '',
                message:
                    <div style={{ display: 'flex' }}>
                        <InfoOutlinedIcon sx={{ color: 'var(--sipzee-yellow)', fontSize: 50 }} style={{ alignSelf: 'center' }} />
                        <div style={{ marginLeft: '15px', marginRight: '15px' }}>
                            <div style={{ marginTop: '10px', fontSize: '16pt', fontWeight: 'bold' }}>Quantity</div>
                            <div style={{ marginTop: '10px' }}>Enter the number of cans/bottles you would like returned. If you are uncertain, please use the Estimator tool to determine an amount.</div>
                        </div>
                    </div>,
                closeButton: 'Ok',
            });
        }
        else if (infoType == 'Photo') {
            setAlertDialog({
                show: true,
                title: '',
                message:
                    <div style={{ display: 'flex' }}>
                        <InfoOutlinedIcon sx={{ color: 'var(--sipzee-yellow)', fontSize: 50 }} style={{ alignSelf: 'center' }} />
                        <div style={{ marginLeft: '15px', marginRight: '15px' }}>
                            <div style={{ marginTop: '10px', fontSize: '16pt', fontWeight: 'bold' }}>Photo</div>
                            <div style={{ marginTop: '10px' }}>Please upload a photograph so our recyclers can verify the accuracy of your order.</div>
                        </div>
                    </div>,
                closeButton: 'Ok',
            });
        }
        else if (infoType == 'Overload') {
            setAlertDialog({
                show: true,
                title: '',
                message:
                    <div style={{ display: 'flex' }}>
                        <InfoOutlinedIcon sx={{ color: 'var(--sipzee-yellow)', fontSize: 50 }} style={{ alignSelf: 'center' }} />
                        <div style={{ marginLeft: '15px', marginRight: '15px' }}>
                            <div style={{ marginTop: '10px', fontSize: '16pt', fontWeight: 'bold' }}>That's a lot!</div>
                            <div style={{ marginTop: '10px' }}>Sorry, our current maximum is { props.orderMaximumQuantity() } cans & bottles because our Recyclers are using their personal vehicles.</div>
                            <div style={{ marginTop: '10px' }}> We recommend submitting a smaller pickup request and after that is complete, submitting additional requests until all of your cans & bottles are recycled.</div>
                        </div>
                    </div>,
                closeButton: 'Ok',
            });
        }
        else if (infoType == 'Underload') {
            setAlertDialog({
                show: true,
                title: '',
                message:
                    <div style={{ display: 'flex' }}>
                        <InfoOutlinedIcon sx={{ color: 'var(--sipzee-yellow)', fontSize: 50 }} style={{ alignSelf: 'center' }} />
                        <div style={{ marginLeft: '15px', marginRight: '15px' }}>
                            <div style={{ marginTop: '10px', fontSize: '16pt', fontWeight: 'bold' }}>Not quite enough</div>
                            <div style={{ marginTop: '10px' }}>Sorry, our current minimum is {props.orderMinimumQuantity()} cans & bottles.</div>
                            <div style={{ marginTop: '10px' }}>Please try again when you have this many.</div>
                            <div style={{ marginTop: '10px' }}>This minimum is necessary to make it worth the drive for your recycler.</div>
                        </div>
                    </div>,
                closeButton: 'Ok',
            });
        }
    }

    function isValidated() {
        let isValid = true;
    

        let errors = {};

        if (typeof quantity === 'string') {

            if (quantity.trim() == '') {
                //errors["Quantity"] = "Quantity is required.";
                isValid = false;
            }
            else {
                if (isNaN(quantity)) {

                    errors["Quantity"] = "Quantity must be a number.";
                    isValid = false;
                }
                else if (parseInt(quantity) <= 0) {

                    errors["Quantity"] = "Quantity must be more than zero.";
                    isValid = false;
                }
                else if (parseInt(quantity) > props.orderMaximumQuantity()) {
                    let message = <div>Maximum is {props.orderMaximumQuantity()}.
                        <IconButton aria-label="More Info" onClick={() => showMoreInfo('Overload')} style={{ marginRight: '10px' }}>
                            <InfoOutlinedIcon sx={{ color: 'var(--sipzee-yellow)', fontSize: 40 }} />
                        </IconButton></div>;
                    errors["Quantity"] = message;
                    isValid = false;
                }
                else if (parseInt(quantity) < props.orderMinimumQuantity()) {
                    let message = <div>Minimum is {props.orderMinimumQuantity()}.
                        <IconButton aria-label="More Info" onClick={() => showMoreInfo('Underload')} style={{ marginRight: '10px' }}>
                            <InfoOutlinedIcon sx={{ color: 'var(--sipzee-yellow)', fontSize: 40 }} />
                        </IconButton></div>;
                    errors["Quantity"] = message;
                    isValid = false;
                }
            }
        }
        else {
            if (parseInt(quantity) <= 0) {

                errors["Quantity"] = "Quantity must be more than zero.";
                isValid = false;
            }
            else if (parseInt(quantity) > props.orderMaximumQuantity()) {
                let message = <div>Maximum is {props.orderMaximumQuantity()}.
                    <IconButton aria-label="More Info" onClick={() => showMoreInfo('Overload')} style={{ marginRight: '10px' }}>
                        <InfoOutlinedIcon sx={{ color: 'var(--sipzee-yellow)', fontSize: 40 }} />
                    </IconButton></div>;
                errors["Quantity"] = message;
                isValid = false;
            }
            else if (parseInt(quantity) < props.orderMinimumQuantity()) {
                let message = <div>Minimum is {props.orderMinimumQuantity()}.
                    <IconButton aria-label="More Info" onClick={() => showMoreInfo('Underload')} style={{ marginRight: '10px' }}>
                        <InfoOutlinedIcon sx={{ color: 'var(--sipzee-yellow)', fontSize: 40 }} />
                    </IconButton></div>;
                errors["Quantity"] = message;
                isValid = false;
            }
        }

        return {
            isValid: isValid,
            errors: errors
        }
    }

   
    function handleUploadImageClick(event) {
        let file = event.target.files[0];
        const reader = new FileReader();
        var url = reader.readAsDataURL(file);

        reader.onloadend = function (e) {


            // resize the imagage
            var img = document.createElement("img");
            img.onload = function (event) {
                var MAX_WIDTH = 300;
                var MAX_HEIGHT = 300;

                var width = img.width;
                var height = img.height;

                // Change the resizing logic
                if (width > height) {
                    if (width > MAX_WIDTH) {
                        height = height * (MAX_WIDTH / width);
                        width = MAX_WIDTH;
                    }
                } else {
                    if (height > MAX_HEIGHT) {
                        width = width * (MAX_HEIGHT / height);
                        height = MAX_HEIGHT;
                    }
                }
                var canvas = document.createElement("canvas");
                canvas.width = width;
                canvas.height = height;
                var ctx = canvas.getContext("2d");
                // Actual resizing
                ctx.drawImage(img, 0, 0, width, height);

     

                // Show resized image in preview element
                var dataurl = canvas.toDataURL(file.type);
                //document.getElementById("preview").src = dataurl;

                let imagesCopy = images.slice();
                imagesCopy.push({
                    imageId: uuidv4(),
                    imageData: dataurl
                });
                setImages(imagesCopy);
            }
            img.src = reader.result;

           
        }.bind(this);
    };

    function removeImage(imageId) {
        let imagesCopy = [];
        for (let i = 0; i < images.length; i++) {
            if (images[i].imageId !== imageId) {
                imagesCopy.push(images[i]);
            }
        }
      
        setImages(imagesCopy);
    }

    function uuidv4() {
        return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
            (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
        );
    }


    function handleNext() {
        //props.onNext();
        props.onNext(quantity, images);
    }

    function getImages() {
        if (images !== null && images.length > 0) {

            return (

                <div className="images">
                    {images.map((img) => (
                        <div key={img.imageId }>
                            <Fab onClick={() => removeImage(img.imageId)}>
                                <DeleteIcon />
                            </Fab>
                            <img
                                src={img.imageData}
                               
                                />
                        </div>
                    ))}
                </div>);
        
        }
        else {
            return null;
        }
        
    }

    let quantitySection = null;
    let headerText = null;
    if (props.pickupRequest.Quantifier === 'Count') {

        headerText = "Please enter the number of cans/bottles";
        quantitySection = (
            <div >
                <TextField autoComplete='off' label="Quantity" error={isValidated().errors['Quantity'] !== undefined} onChange={(e) => setQuantity(e.target.value)} value={quantity} variant="outlined" style={{ maxWidth: '175px' }} inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }} />
                <div style={{ color: 'var(--sipzee-red)' }}> {isValidated().errors['Quantity'] !== undefined ? isValidated().errors['Quantity'] : ''}</div>
            </div>
        );
    }
    else {
        // customer used the Estimate tool
        headerText = "Estimated number of Cans/Bottles";
        quantitySection = (
            <div style={{ marginLeft: '70px', marginTop:'15px' }} className={styles.cardImportant}>
                Estimated Quantity: {quantity}
                <div style={{ color: 'var(--sipzee-red)' }}> {isValidated().errors['Quantity'] !== undefined ? isValidated().errors['Quantity'] : ''}</div>
            </div>
        );
    }

    return (
        <div style={{ maxWidth: '400px', marginLeft: 'auto', marginRight: 'auto' }}>
            <div className={styles.cardHeader}>{headerText }</div>

           
            <div style={{ display: 'flex' }}>
                {props.pickupRequest.Quantifier !== 'Count' ? null :
                    <IconButton aria-label="More Info" onClick={() => showMoreInfo('Quantity')} style={{ marginRight: '10px' }}>
                        <InfoOutlinedIcon sx={{ color: 'var(--sipzee-yellow)', fontSize: 40 }} />
                    </IconButton>
                }
                    {quantitySection}
                </div>
            
          

            <div style={{ display: 'flex',marginTop:'15px'}}>
                <IconButton aria-label="More Info" onClick={() => showMoreInfo('Photo')} style={{ marginRight: '10px', alignSelf:'flex-start' }}>
                    <InfoOutlinedIcon sx={{ color: 'var(--sipzee-yellow)', fontSize: 40 }} />
                </IconButton>
                <div style={{ display: 'flex', justifyContent: 'flex-start', flexDirection: 'column' }}>
                    <Button variant='outlined' style={{ backgroundColor: 'var(--sipzee-yellow)' }} onClick={() => imageInputRef.current.click()}>
                        Add Photos
                        <AddAPhotoIcon />
                    </Button>                   
                    <div style={{ color: 'var(--sipzee-red' }}>* Recommended</div>
                    <input
                        ref={imageInputRef}
                        style={{ display: 'none' }}
                        accept="image/*"
                        id="contained-button-file"
                        multiple
                        type="file"
                        onChange={handleUploadImageClick}
                    />
                   
                </div>
            </div>

            <div className={styles.cardImportant} style={{marginTop:'15px'} }>
                Payment to you: {props.calculatePayment(quantity)}
            </div>

            <div style={{display:'flex', marginTop:'15px'} }>
               {getImages()}
            </div>

            <div style={{ display: 'flex', justifyContent: 'center', marginTop: '30px' }} >
                <div style={{ display: 'flex', width: '300px', justifyContent: 'space-between' }}>
                    <Button variant="outlined" onClick={props.onBack} style={{ marginRight: '2px' }}><KeyboardArrowLeft /> Back</Button>
                    <Button variant={isValidated().isValid ? "contained" : "outlined"} color="sipzeeGreen" disabled={!isValidated().isValid} onClick={() => handleNext()}>Next <KeyboardArrowRight /></Button>
                </div>
            </div>
            <AlertDialog isShown={alertDialog.show} close={() => setAlertDialog({ show: false })} Title={alertDialog.title} Message={alertDialog.message} CloseText={alertDialog.closeButton} />
        </div>
    );
}